// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation_wrapper__2g0Je"};